import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { DEAD_LINK_COPY, HandoffPanel } from '../../components/auth/HandoffPanel'

/**
 * `/auth/handoff` with no token.
 *
 * Two ways to get here, and the answer is the same for both. The route exists
 * mainly for the second:
 *
 *  - a truncated or hand-typed link (the backend's own `400 token is required`
 *    case, caught before it costs a round trip);
 *  - a RELOAD after a redemption. `useHandoffRedemption` rewrites the address
 *    bar to this path before it does anything else, so the live credential is
 *    not left sitting where it can be copied or bookmarked. Without a route
 *    here, pressing F5 a second later would land on the catch-all's
 *    "not part of this deployment" page — which is both wrong and alarming.
 */
function HandoffNoTokenPage() {
  const navigate = useNavigate()
  return (
    <HandoffPanel
      title="Sign-in link expired"
      action={{ label: 'Go to sign in', onPress: () => void navigate({ to: '/auth/login', replace: true }) }}
    >
      {DEAD_LINK_COPY}
    </HandoffPanel>
  )
}

export const Route = createFileRoute('/auth/handoff/')({
  component: HandoffNoTokenPage,
})
